import styled from "styled-components";
import {GameTitleDefaultBox} from "./game-title.default.box";

export const GameTitleCipBox = styled(GameTitleDefaultBox)`
  @media ${({theme}) => theme.mediaQuery.lAndBelow} {
    font-family: ${props => props.theme.font.family.regular};
  }
`